import styled from 'styled-components';
import { Breakpoints, Colors } from 'styles/Constants';

export const SectionForm = styled.form`
  margin-left: 150px;
  padding: 0 50px 20px;
  @media (max-width: ${Breakpoints.medium}) {
    margin: 0 0%;
    width: 100%;
  }

  select {
    -moz-appearance: none;
    -webkit-appearance: none;
    background-image: url(/static/media/dropdown-disable.4dd4bae1.svg);
    -webkit-transition: all 0.1s ease-out 0s;
    transition: all 0.1s ease-out 0s;
    background-repeat: no-repeat;
    background-position: 90% 50%;
    background-size: 22px;
    padding-right: 50px;
    height: 40px;
    width: 300px;
    -webkit-transition: all 0.5s ease-out 0s;
    transition: all 0.5s ease-out 0s;
    font-family: 'Montserrat', sans-serif;
    background-color: #ffffff;
    border: 1px solid #979797;
    font-size: 0.8125rem;
    color: #4d4d4d;
    border-radius: 10px;
    padding: 10px 15px;
    font-weight: 400;
    display: block;
    outline: none;
  }

  .inputRadio {
    margin-top: 20px;
    display: flex;
    width: 100%;
    margin-top: 15px;
    margin-left: 4%;
    margin-right: 20%;
    div {
      display: flex;
      label {
        margin-top: -8px;
        margin-right: 15px;
        margin-left: 20px;
        font-size: 13px;
      }
    }
    input {
      margin-left: 0%;
      margin-right: 0%;
      @media (max-width: ${Breakpoints.medium}) {
        margin-top: -5px;
      }
    }
  }

  .disabled-field {
    cursor: not-allowed;
    opacity: 0.7;
    select,
    input {
      pointer-events: none;
    }
  }
`;

export const ButtonStyled = styled.div`
  button {
    text-align: center;
    margin: auto;
    margin-top: 30px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
  }
`;

export const InputWrapper = styled.div`
  display: flex;

  margin: 20px 0;

  @media (max-width: ${Breakpoints.medium}) {
    display: grid;
  }

  label {
    margin-top: 8px;
    padding: 10px;
    width: 10%;
    color: #4d4d4d;
    font-size: 1rem;
    font-weight: 600;
    margin-right: 40px;
    @media (max-width: ${Breakpoints.medium}) {
      padding: 0px;
    }
  }

  .inputRadio {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .inputRadio input {
    appearance: none;
    background: #d8d8d8;
    border-radius: 3em;
    cursor: pointer;
    outline: none;
    border: none;
    height: 10px;
    width: 44px;
    position: relative;
    transition: background 0.3s ease;
  }

  .inputRadio input:checked {
    background: #7ed321;
  }

  .inputRadio input::after {
    content: '';
    position: absolute;
    top: 1px;
    left: 1px;
    width: 20px;
    height: 20px;
    background: #fff url('/static/media/check.svg') no-repeat center;
    background-size: 12px;
    border-radius: 50%;
    transition: transform 0.25s ease;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  }

  .inputRadio input:checked::after {
    transform: translateX(22px);
    background-color: #92e239;
    background-image: url('/static/media/check.svg');
  }

  textarea {
    margin-left: 14%;
    margin-left: 3%;
    transition: all 0.5s ease-out 0s;
    font-family: 'Montserrat', sans-serif;
    background-color: #ffffff;
    border: 1px solid #979797;
    font-size: 0.8125rem;
    color: ${Colors.secondaryNormalGrey};
    border-radius: 10px;
    padding: 10px 15px;
    font-weight: 400;
    width: 360%;
    max-width: 1000px;
    height: 180px;
    outline: none;
    @media (max-width: ${Breakpoints.medium}) {
      margin-left: 2%;
      max-width: 65%;
    }
  }

  .cutText {
    margin-top: 15px;
    margin-bottom: auto;
    width: 180px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }


  .marginUpload select {
    margin-bottom: 10px;
  }

  .checkbox {
    display: flex;
    width: 70%;
    margin-top: 20px;
    margin-right: 20px;
    @media (max-width: ${Breakpoints.medium}) {
      width: 50%;
      margin-top: 0px;
      margin-right: 1px;
    }
  }

  div.dropdown-filter-container {
    margin-top: 15px;
    margin-left: 6%;
    margin-right: 20%;
    @media (max-width: ${Breakpoints.medium}) {
      display: grid;
      width: 100%;
      margin-left: 0%;
    }
  }

  div.dropdown-filter-content__control {
    width: 250px;
    border: 1px solid #979797;
    border-radius: 30px;
    background-color: transparent;
    box-shadow: none;
    height: 30px;

    &:hover,
    &:focus-within {
      border-color: ${Colors.primaryDarkBlue};
      cursor: pointer;
    }
  }

  div.dropdown-filter-content__single-value {
    color: #3e66fe;
    font-weight: 500;
    font-size: 13px;
    text-transform: uppercase;
  }

  div.dropdown-filter-content__value-container {
    margin-left: 2%;
    margin-top: -6px;
  }

  span.dropdown-filter-content__indicator-separator {
    display: none;
  }

  div.dropdown-filter-content__indicator {
    color: rgba(0, 0, 0, 0.54);
  }

  div.dropdown-filter-content__placeholder {
    margin-top: 8px;
    padding-bottom: 15px;
    font-size: 15px;
    color: ${Colors.inactive};
  }

  div.dropdown-filter-content__menu {
    margin-top: 1px;
    width: 170px;
    box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),
      0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 8px 10px 1px rgba(0, 0, 0, 0.14);
    z-index: 5;
  }

  div.dropdown-filter-content__menu-list {
    padding-top: 0;
    &::-webkit-scrollbar {
      display: none;
    }
  }

  div.dropdown-filter-content__option {
    padding: 6px 8px;
    font-size: 14px;
  }

  div.dropdown-filter-content__option--is-focused {
    background: transparent;
  }

  div.dropdown-filter-content__option:hover,
  div.dropdown-filter-content__option--is-focused:hover,
  div.dropdown-filter-content__option--is-selected {
    background: rgba(0, 0, 0, 0.08);
    font-weight: 500;
    color: #3e66fe;
  }
     .customUpload {
    margin-left: 40%;
    margin-right: 20%;
`;

export const TextCheckbox = styled.p`
  margin-top: 15px;
  color: #4d4d4d;
  font-size: 1rem;
  font-weight: 600;
  @media (max-width: ${Breakpoints.medium}) {
    width: 100%;
  }
`;
export const CalendarSection = styled.div`
  label {
    margin: 0;
    padding: 0;
    width: 100%;
  }
  select {
    width: auto;
    appearance: none;
    -webkit-appearance: none;
    border: 0;
    background: transparent;
    padding: 10px 30px 10px 10px;
    border-radius: 4px;
    outline: 0;
    color: #3e484f;
    background-image: url(/static/media/dropdown-disable.4dd4bae1.svg);
    background-repeat: no-repeat;
    background-position: 90% 50%;
    background-size: 22px;
    cursor: pointer;
    text-align: center;
  }
`;
